import { SET_REDUX_STATE, SET_INITIAL_VALUE } from "../constants";

export const INITIAL_STATE: any = {};

export default (
  state = INITIAL_STATE,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case SET_INITIAL_VALUE:
      return { ...state, ...payload };
    case SET_REDUX_STATE: {
      return { ...state, ...payload };
    }
    default:
      return state;
  }
};
